import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/i18n";
import { pageHead } from "@/lib/seo";
import { SecurityPage } from "@/pages/beveiliging";

export const Route = createFileRoute("/$lang/securite")({
  head: ({ params }) => {
    const lang = (params.lang as "fr" | "en") ?? "fr";
    const t = i18n.getFixedT(lang, "security");
    return pageHead({ lang, pathWithoutLang: "/beveiliging", title: t("seo.title"), description: t("seo.description") });
  },
  component: SecurityPage,
});
